import axios, { setAuthToken } from './axios';

/**
 * Login user
 */
export const loginUser = async (username, password) => {
  const response = await axios.post('auth/login/', { username, password });
  const { token, username: loggedUsername } = response.data;
  localStorage.setItem('token', token);
  localStorage.setItem('username', loggedUsername);
  setAuthToken(token);
  return response.data;
};

/**
 * Logout user
 */
export const logoutUser = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('username');
  setAuthToken(null);
};

/**
 * Get current username
 */
export const getCurrentUsername = () => {
  return localStorage.getItem('username') || 'Unknown User';
};

/**
 * Authentication API service
 */
export const authApi = {
  login: loginUser,
  logout: logoutUser
};

export default authApi;
